import sileo from 'sileo';

const MilestoneEvA = new sileo.Model('hqzen', 'milestone-eva');
const QueuedProcessProgressState = new sileo.Model('hqzen', 'queued-process-progress-state');
const QueuedProcessEvA = new sileo.Model('hqzen', 'queued-process-eva');

const state = {};

const getters = {};

const mutations = {};

const actions = {
    calculateMilestoneEvA(context, filters={}) {
        return MilestoneEvA.objects.filter(filters);
    },

    fetchQueuedProcessProgressState(context, filters={}) {
        return QueuedProcessProgressState.objects.filter(filters);
    },

    fetchSavedEvA(context, filters={}) {
        return QueuedProcessEvA.objects.filter(filters);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
